import { create } from 'zustand';

interface SidebarState {
  isSidebarOpen: boolean,
  setIsSidebarOpen: (updater: boolean | ((prev: boolean) => boolean)) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isSidebarOpen: false,
  setIsSidebarOpen: (updater) => set((state) => ({
    isSidebarOpen: typeof updater === 'function' ? updater(state.isSidebarOpen) : updater,
  })),
}));
